import {ChangeDetectorRef, Component, Input, OnChanges, OnInit, ViewChild} from '@angular/core';
import {ValidationConstraint} from "../../domain/validation-constraint";
import {BaseSelectComponent} from "../base-select/base-select.component";
import {MatSelectChange} from "@angular/material/select";

@Component({
    selector: 'app-custom-multiple-select',
    templateUrl: './custom-multiple-select.component.html',
    styleUrls: ['./custom-multiple-select.component.scss']
})
export class CustomMultipleSelectComponent extends BaseSelectComponent implements OnInit, OnChanges {
    @Input() result: any[];

    @ViewChild('frm', {static: true}) form: any;
    public error: string;

    public fieldValidationConstraints: ValidationConstraint[];

    constructor(cd: ChangeDetectorRef) {
        super(cd);
    }

    ngOnInit(): void {
        super.ngOnInit();
    }

    onSelectionChanged($event: MatSelectChange) {
        this.resultChange.emit($event.value);
    }
}
